import request from '@utils/request'
import configRequest from "@src/config/request";

export const state = {}

export const mutations = {}

export const actions = {
  /**
   * 取得商品項目
   * @param commit
   * @param getters
   * @param alias
   * @returns {Promise<AxiosResponse<any>>}
   */
  fetchItem({ commit, getters }, alias) {
    return request
      .get(`/product/${ alias }`, {
        ...configRequest,
        name: 'fetchItem'
      })
      .then((response) => {
        return response.items
      })
  },

  /**
   * 取得商品列表
   * @param commit
   * @param params
   * @returns {Promise<{pagination: *, items: *}>}
   */
  fetchList({ commit }, params) {
    return request
      .post(`/product/search`, params, {
        ...configRequest,
        name: 'fetchList'
      })
      .then(({ items, pagination }) => {
        return {
          items,
          pagination
        }
      })
  },
}
